import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getNewsList = (newsData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_NEWS_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/news/list`,
        newsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_NEWS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_NEWS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_NEWS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNews = (newsData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_NEWS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/news/add`,
        newsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_NEWS_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_NEWS_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "ADD_NEWS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editNews = (newsData, id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_NEWS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/news/update/${id}`,
        newsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_NEWS_SUCCESS", payload: data });
        toast.success("Edit Successfully!!");
        return data;
      } else {
        dispatch({ type: "EDIT_NEWS_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "EDIT_NEWS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewNews = (newsData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_NEWS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(`${BASE_URL}/news/view/${newsData}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_NEWS_SUCCESS", payload: data });

        return data;
      } else {
        dispatch({ type: "VIEW_NEWS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_NEWS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
